import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Pipeline} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../../utils/TableTimestamps.tsx";
import {PipelineStatusBadge} from "../components/PipelineStatusBadge.tsx";


export const usePipelinesTableColumns = () => {

    const columns: DataTableColumn<Pipeline>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Pipeline) => <NavLink to={`/pipelines/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'pipelineType',
            title: I18n.get('Pipeline Type'),
            width: '1fr',
            render: (item: Pipeline) => item.pipelineType,
        },
        {
            accessor: 'codeRepositoryName',
            title: I18n.get('Repository'),
            width: '1fr',
            render: (item: Pipeline) => item.codeRepositoryName,
        },
        {
            accessor: 'pipelineStatus',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Pipeline) => <PipelineStatusBadge status={item.pipelineStatus}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Pipeline) => formatTimestamp(item.created as string),
        },
    ];

    return {
        columns,
    };
};
